import { jsx as _jsx } from "react/jsx-runtime";
import "./Shimmer.scss";
const CSS_PREFIX = `lav-shimmer`;
export const Shimmer = ({ style }) => {
    return _jsx("div", { style: style, className: `${CSS_PREFIX}-animate` });
};
